import * as _ from 'lodash';
import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IProject, IProposition, IStep, IUser } from 'src/model';
import { WorkspaceMessageListWithGlobalContext } from './WorkspaceMessageList/WorkspaceMessageList';
import { WorkspacePropositionCard } from './WorkspacePropositionCard';
import { WorkspaceStepList } from './WorkspaceStepList/WorkspaceStepList';

interface IProjectWorkspaceProps {
  client: IUser;
  consultant: IUser;
  project: IProject;
  proposition: IProposition;
}

const ProjectWorkspace: React.SFC<
  IProjectWorkspaceProps & IGlobalContextProps
> = ({ client, consultant, context, project, proposition }) => {
  const { user, updateProject } = context;

  const handleStepListChange = (step: IStep) => {
    const stepList = proposition.stepList;
    const stepIndex = _.findIndex(stepList, { _id: step._id });
    stepList[stepIndex] = step;
    const updatedProject = {
      ...project,
      proposition: {
        ...project.proposition,
        stepList,
      },
    };
    updateProject(updatedProject);
  };

  return (
    <Row className='p-5'>
      <Col md='12'>
        <Row>
          <span className='text-dark' style={{ fontSize: '32px' }}>
            {project.title}
          </span>
        </Row>
        <WorkspacePropositionCard
          proposition={proposition}
          user={user && user.type === 'client' ? consultant : client}
        />
        <Row className='mt-4'>
          <Col md='7' xs='auto'>
            <WorkspaceStepList
              stepList={proposition.stepList}
              handleStepListChange={handleStepListChange}
            />
          </Col>
          <Col className='border-left pl-5' md='5' xs='auto'>
            <WorkspaceMessageListWithGlobalContext
              client={client}
              consultant={consultant}
              messageList={proposition.messageList}
              proposition={proposition}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export const ProjectWorkspaceWithGlobalContext = withGlobalContext(
  ProjectWorkspace
);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectWorkspace/ProjectWorkspace.tsx